export const userStaticDefaults = {
  accessGroups: [
    'Access group 1',
    'Access group 2',
    'Access group 3',
    'Access group 4',
    'Access group 5',
  ],
  schedules: [
    '24/7 Always',
    'Business Hours (8AM–6PM)',
    'Extended Hours (6AM–10PM)',
    'Weekdays Only',
    'Custom',
  ],
  defaultDraft: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    department: '',
    title: '',
    employmentNumber: '',
    userGroup: 'None',
    mobileNumber: '',
    address: '',
    credentialType: 'card' as const,
    cardNumber: '',
    cardFormat: '26-bit Wiegand (H10301)',
    facilityCode: '',
    pin: '',
    accessGroups: ['Access group 1'],
    schedule: '24/7 Always',
    activationDate: new Date().toISOString().split('T')[0],
    expirationDate: '',
  },
  operatorPrefill: {
    firstName: 'Arjun',
    lastName: 'Kumar',
    email: 'arjun.kumar@assaabloy.com',
    phone: '',
    department: '',
    title: '',
    employmentNumber: 'CHN-EMP-2047',
    userGroup: 'None',
    mobileNumber: '+91 88405 12367',
    address: '',
    credentialType: 'card' as const,
    cardNumber: '582104',
    cardFormat: '26 bits Standard',
    facilityCode: '3432',
    pin: '',
    accessGroups: ['Access group 1'],
    schedule: '24/7 Always',
    activationDate: '2026-01-18',
    expirationDate: '2027-01-18',
  },
  operatorAiFilledFields: [
    'firstName',
    'lastName',
    'email',
    'employmentNumber',
    'mobileNumber',
    'cardNumber',
    'cardFormat',
    'facilityCode',
    'activationDate',
    'expirationDate',
  ],
  success: {
    userName: 'John Smith',
    summaryLine:
      'Card credential · 26-bit Wiegand · Access group 1 · Active immediately',
    nextSteps: [
      { id: 'view-user', label: 'View user profile' },
      { id: 'add-credential', label: 'Add another credential' },
      { id: 'assign-group', label: 'Assign to more groups' },
    ],
  },
  operatorSuccess: {
    userName: 'Priya Venkatesh',
    summaryLine:
      'Priya Venkatesh · priya.venkatesh@assaabloy.com · 26-bit Standard · 00036',
    nextSteps: [
      { id: 'open-user', label: 'Open Priya' },
      { id: 'add-credential', label: 'Add another credential' },
      { id: 'add-user', label: 'Add another user' },
      { id: 'edit-credential', label: 'Edit credential for this user' },
      { id: 'edit-details', label: 'Edit user details' },
    ],
  },
  explainability:
    'Based on your site and the user details provided, I prepared a card credential with standard Wiegand format and full access. You can change any field before approving.',
  assistantHint:
    'I’ll help you add a user to First floor. Use the steps below, or send their details in one message and I’ll select and fill the form for you to review. Example: “Add Priya Venkatesh, email priya.v@company.com, card 458921, facility 120, access group Building A.”',
} as const;
